import { Button, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Box } from '@mui/system'
import { LoginAuthProvider } from '../../../types/auth'
const Google = process.env.PUBLIC_URL + '/images/social-google.webp'

// interface propType {
//   step: number
//   setStepValue: number
//   handleClose: () => void
//   handleSignUp: (provider: LoginAuthProvider, args?: { email: string; password: string }) => void
// }

export default function GoogleSignUpButton(props: any) {
  const theme = useTheme()
  const { handleSignUp} = props

  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <Box>
      <link rel="preload" href={Google} as="image" />
      <Button
        id="GoogleLoginButton"
        disableElevation
        onClick={() => handleSignUp(LoginAuthProvider.Google)}
        fullWidth
        size="large"
        variant="outlined"
        sx={{
          display: 'flex',
          width: '100% !important',
          borderRadius: '8px !important',
          boxShadow: '2px 2px 4px #ddd',
          borderColor: '#ddd',
          height: '45px',
          alignItems: 'center',
          color: '#7b7b7b',
          mb: 2,
          fontWight: '600'
        }}
      >
        <Box sx={{ mr: { xs: 1, sm: 2, width: 20 } }}>
          <img
            src={Google}
            loading="eager"
            aria-label="For google"
            alt="googleLogo"
            width={18}
            height={18}
            style={{ marginRight: matchDownSM ? 8 : 16, marginTop: '8px' }}
          />
        </Box>
        Sign Up with Google
      </Button>
    </Box>
  )
}
